import * as React from 'react';
import { View } from 'react-native';
export default function CrashingComponent() {
  return /*#__PURE__*/React.createElement(View, null, "''");
}
//# sourceMappingURL=CrashingComponent.js.map